export interface ApiResponse {
    warnings: WarningCollection[];
    hash: number;
}

export interface WarningCollection {
    collectionSize: number;
    category: string;
    classWarnings: ClassWarning[];
    objectWarnings: ObjectWarning[];
}

export enum WarningType {
    SiteNotFound = 'SiteNotFound',
    ChannelNotFound = 'ChannelNotFound',
    ProductionLineNotFound = 'ProductionLineNotFound',
    ConsumptionNotFound = 'ConsumptionNotFound',
    RecipeNotFound = 'RecipeNotFound',
    ProductNotFound = 'ProductNotFound',
    BlankFieldNotAllowed = 'BlankFieldNotAllowed',
    InvalidValue = 'InvalidValue',
    ConflictingIdentifiers = 'ConflictingIdentifiers',
    EntityWithoutTarget = 'EntityWithoutTarget',
    UnnecessaryField = 'UnnecessaryField',
    SubDemandNotFound = 'SubDemandNotFound',
    IdentifierRecurrence = 'IdentifierRecurrence',
    IdentiferNotFound = 'IdentiferNotFound',
    PropertyNotFound = 'PropertyNotFound',
    NotEnoughPermissions = 'NotEnoughPermissions'
}

export enum WarningResponseType {
    SkipEntity = 'SkipEntity',
    SkipInnerEntity = 'SkipInnerEntity',
    LinkBroken = 'LinkBroken',
    IgnoreField = 'IgnoreField'
}

export interface Warning {
    fieldName: string;
    type: WarningType;
    response: WarningResponseType;
}

export enum WarningElementType {
    Class = 'class',
    Object = 'object'
}

export interface ClassWarning extends Warning {
    affectedElements: number;
}

export interface ObjectWarning extends Warning {
    sourceId: string;
    targetId: string;
    rowNumber: number;
}

export interface ApiUploadOptions {
    confirmedWarnings?: number;
    refreshContext?: boolean;
    ignoreWarnings?: boolean;
    trackStages?: boolean;
}
